import { useEffect } from 'react'
import { DadosContainerDefault } from '../../components/Styles'
import Dashboard from '../../components/Dashboard'

function DashboardPage() {
  useEffect(() => {
    document.title = 'Dashboard | Gesttor'
  })
  return (
    <DadosContainerDefault>
      <Dashboard />
    </DadosContainerDefault>
  )
}

export default DashboardPage
